import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Backdrop from "Components/Common/Backdrop/Backdrop";

const ProgressIndicator = ({ loading, message }) => {
  const isLoading = Array.isArray(loading) && loading.length > 0;

  if (!isLoading) {
    return null;
  }

  // fallback message if empty, null, or just whitespace
  const displayMessage =
    typeof message === "string" && message.trim() !== ""
      ? message
      : "Processing...";

  return (
    <>
      <div className="[ progress-indicator-container ]">
        <div className="[ icon loading-icon fa-spin ]" />
        <span className="progress-message">{displayMessage}</span>
      </div>
      <Backdrop show />
    </>
  );
};

ProgressIndicator.propTypes = {
  loading: PropTypes.arrayOf(PropTypes.string),
  message: PropTypes.string,
};

ProgressIndicator.defaultProps = {
  loading: [],
  message: null,
};

const mapStateToProps = (state) => ({
  loading: state.ProgressIndicatorReducer.loading,
  message: state.ProgressIndicatorReducer.message,
});

export default connect(mapStateToProps)(ProgressIndicator);
